module.exports = __webpack_public_path__ + "fonts/OpenSans-SemiBold.2b370b1.ttf";